import * as React from "react";
import { Backdrop, Box, CircularProgress, Typography, LinearProgress } from "@mui/material";

function Spinner({ progress, message, dense }) {
  const hasProgress = typeof progress === "number" && !Number.isNaN(progress);
  const pct = hasProgress ? Math.max(0, Math.min(100, progress)) : undefined;

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={dense ? 1 : 2}>
      <CircularProgress size={dense ? 36 : 48} thickness={4} variant={hasProgress ? "determinate" : "indeterminate"} value={pct} />
      {message ? (
        <Typography variant={dense ? "body2" : "body1"} sx={{ opacity: 0.9, textAlign: "center" }}>
          {message}
        </Typography>
      ) : null}
      {hasProgress ? (
        <Box minWidth={220} width="100%">
          <LinearProgress variant="determinate" value={pct} />
          <Typography variant="caption" sx={{ display: "block", textAlign: "right", mt: 0.5 }}>
            {Math.round(pct)}%
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}

export default function LoadingPage({
  open = true,
  message = "Loading...",
  progress, 
  variant = "fullscreen",
  dense = false,
  children,
  backdropSx,
  overlaySx,
  ...boxProps
}) {
  if (variant === "inline") {
    return (
      <Box position="relative" {...boxProps}>
        <Box sx={{ pointerEvents: open ? "none" : "auto", opacity: open ? 0.6 : 1 }}>{children}</Box>
        {open && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              backgroundColor: "rgba(0,0,0,0.08)",
              backdropFilter: "blur(1.5px)",
              ...overlaySx,
            }}
          >
            <Spinner progress={progress} message={message} dense={dense} />
          </Box>
        )}
      </Box>
    );
  }

  if (variant === "page") {
    return (
      <Box minHeight="60vh" display="flex" alignItems="center" justifyContent="center" {...boxProps}>
        <Spinner progress={progress} message={message} dense={dense} />
      </Box>
    );
  }

  // default: fullscreen backdrop
  return (
    <Backdrop
      open={!!open}
      sx={(theme) => ({
        color: theme.palette.common.white,
        zIndex: (theme) => theme.zIndex.modal + 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        ...backdropSx,
      })}
    >
      <Spinner progress={progress} message={message} dense={dense} />
    </Backdrop>
  );
}
